<pr-form
  (onSubmit)="onSubmit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
  [formWithTabs]="true"
  (nextTab)="nextTab()"
  [tabChanged]="tabChanged"
>
  <input formControlName="id" type="hidden" />

  <!-- <pr-input-autosuggest formControlName="product" label="Produit" [options]="products" [derrors]="derrors"
  [hidden]="isAutomaticFlux" [optionLabel]="'name'">
</pr-input-autosuggest> -->

  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="onCancel()"
    ></pr-icon>
  </button>

  <pr-tabs
    clazz="drawer-tab-button"
    [defaultTextColor]="false"
    [changeTab]="changeTab"
    (lastTab)="onTabChange($event)"
  >
    <pr-tab label="Informations générales">
      <pr-input-autosuggest
        formControlName="contratId"
        label="Gestionnaire"
        [options]="managers"
        [derrors]="derrors"
        [optionLabel]="'name'"
      >
        <span customOptionText
          >Ce gestionnaire sera créé lors de l'enregistrement.</span
        >
      </pr-input-autosuggest>

      <pr-input-date
        formControlName="startDate"
        label="Date d’acquisition"
        [derrors]="derrors"
      ></pr-input-date>

      <pr-input [label]="'Montant actuel'" [suffix]="'€'" [derrors]="derrors">
        <input formControlName="lastValue" type="text" />
      </pr-input>

      <pr-input
        [label]="'Versement mensuel'"
        [suffix]="'€'"
        [derrors]="derrors"
      >
        <input formControlName="monthlyPayment" type="text" />
      </pr-input>

      <pr-input [label]="'Montant investi'" [derrors]="derrors">
        <input formControlName="purchasePrice" type="text" />
      </pr-input>
    </pr-tab>
    <pr-tab label="Détention">
      <pr-input label="Acquis au travers de" [derrors]="derrors">
        <mat-select formControlName="subscriptionSource">
          @for (item of sources; track item) {
            <mat-option [value]="item.id">
              {{ item.label }}
            </mat-option>
          }
        </mat-select>
      </pr-input>

      <pr-input-owner-share
        formControlName="owners"
        [derrors]="derrors"
      ></pr-input-owner-share>
    </pr-tab>
  </pr-tabs>
</pr-form>
